/**
 * @requires ./frc.js
 */

frc.pages.menus = {

	"init": function() {
		var self = frc.page = frc.pages.menus;
/*
		$('.listing-state-nav').pinUp({
            class: 'pinned',
            container: 'section.block-list .wrapper',
            offset: {
                element: '.nav-container'
            }
        });
*/
        frc.init.modules.listingNav();
		$(window).trigger('listing-loaded');
	}
};

